// src/com/auto_rotation_his/AutoRotationHisGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTO_ROTATION_HIS Apollo Graphql
 * 배차 차종 통계
 * Project: NewTOP for cloud
 * 2025-04-11 10:59:49 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const AUTO_ROTATION_HIS_LIST_PART = gql`
fragment AutoRotationHisListPart on AutoRotationHis {
    dcCd
    planDate
    vehTypeId
    vehTypeName
    dcName
    runNum
    vehCnt
    nextDayVehCnt
    charge
    rotationRate
    time00
    time01
    time02
    time03
    time04
    time05
    time06
    time07
    time08
    time09
    time10
    time11
    time12
    time13
    time14
    time15
    time16
    time17
    time18
    time19
    time20
    time21
    time22
    time23
    time24
    usingCarCnt
}
`;


export const LIST_AUTO_ROTATION_HIS = gql`
${AUTO_ROTATION_HIS_LIST_PART}
query ListAutoRotationHis($dcCd:String, $planDate:String!) {
    autoRotationHisList(dcCd:$dcCd, planDate:$planDate) {
        ...AutoRotationHisListPart
    }
}
`;

export const BUILD_AUTO_ROTATION_HIS = gql`
mutation BuildAutoRotationHis($autoRotationHis: InputAutoRotationHisBuild!) {
    autoRotationHisBuild(autoRotationHis: $autoRotationHis) {
        ok
        message
    }
}
`;
